import React, { useContext, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { SetLoyalCardInputActive } from '../../../actions/terminal';

import './style.scss';

const LoyalCardInputPopup = () => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);

  useEffect(() => {
    dispatch(SetLoyalCardInputActive(true));

    return () => {
      dispatch(SetLoyalCardInputActive(false));
    };
  }, []);

  return (
    <div className="popup-content popup-small">
      <div className="title-row">
        <p className="title-row-text">
          {t('Apply Loyalty Card')}
        </p>
      </div>
      <div className="popup-main-content">
        <p className="text-center">{t('Please scan your loyalty card.')}</p>

        <div className="rfid-card-icon-wrapper">
          <i className="global-icon icon-rfid-scan" />
        </div>
      </div>

      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={closePopup}
        >
          {t('Cancel')}
        </button>
      </div>
    </div>
  );
};

export default connect()(LoyalCardInputPopup);